import React, { ReactElement, useContext } from 'react';
import { Immutable } from '@wds/utils';
import { Sheet } from '@wds/sheet';
import { Typography } from '@wds/typography';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { IconLaunchpad } from '@wds/icons';
import { t, defineMessages } from '@sm/intl';
import { Responsive } from '@wds/responsive';

import { MenuItems } from './MenuItems';
import HeaderContext from '../../HeaderContext';
import { NavButton } from '../nav-button';
import useStyles from './useStyles';
import {
  getProductsItems,
  getProductsfootnote,
} from '../../../components/Drawer/getDrawerData';

const COPYPROD = defineMessages({
  PRODUCTS: {
    id: 'ProductsMenu.products',
    defaultMessage: 'Products',
    description:
      '[Type: Label][Vis.: high] - This is the Products title of the side menu.',
  },
});

export type ProductsMenuProps = Immutable<{
  showProducts: boolean;
}> & {
  toggleProducts(): void;
};

const ProductsMenu = ({
  showProducts,
  toggleProducts,
}: ProductsMenuProps): ReactElement => {
  const { lang, isEUDC } = useContext(HeaderContext);
  const classes = useStyles();
  const itemsData = getProductsItems(lang, isEUDC);

  return (
    <Responsive minWidth="xl">
      {matches =>
        matches ? (
          <>
            <NavButton
              onClick={toggleProducts}
              label="Open Products list"
              active={showProducts}
            >
              <Box>
                <IconLaunchpad title="Products icon" size="lg" />
              </Box>
            </NavButton>
            <Sheet show={showProducts} onClose={toggleProducts} offsetTop={48}>
              <Box pt={5} pl={5} pr={5}>
                <Typography variant="sectionTitle">
                  {t(COPYPROD.PRODUCTS)}
                </Typography>
              </Box>
              <List interactive noRules>
                {itemsData.map(
                  props => props && <MenuItems {...props} key={props.title} />
                )}
              </List>
              <Box flexWrap pt={1} px={5} pb={6} className={classes.footnote}>
                <Typography variant="bodySm" color="dark">
                  <em>{getProductsfootnote()}</em>
                </Typography>
              </Box>
            </Sheet>
          </>
        ) : (
          itemsData.map(
            props => props && <MenuItems {...props} key={props.title} />
          )
        )
      }
    </Responsive>
  );
};

export default ProductsMenu;
export { ProductsMenu };
